(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }
    return state;
  };

  window.swinger.app({
    type: 'autocomplete',
    component: 'autocomplete',
    reducer: reducer(),
  })
    .then((app) => {
      const isClickDummy = (
        window.swinger.config
      && window.swinger.config.isClickDummy
      );
      const state = app.store.getState();
      const baseUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.autocomplete}`;
      let debounce;

      const emptyState = () => {
        Object.assign(state, {
          filters: [],
          results: [],
          term: '',
        });
        app.store.dispatch({
          type: 'UPDATE',
          value: state,
        });
      };

      if (state.inputId && window.swinger.$(`#${state.inputId}`).length) {
        const input = window.swinger.$(`#${state.inputId}`)[0];
        window.swinger.visibility.observe(input, (isVisible) => {
          if (isVisible) {
            return;
          }

          emptyState();
        });
      }

      let previousValue = 0;
      let timer;

      app.bindEvent('swinger-widget:rendered', (e) => {
        const widget = window.swinger.eventHub.getTarget(e);
        const list = widget.querySelector('[role="listbox"]');
        const totalCount = list.querySelectorAll('[role="option"]').length;

        list.scrollTop = 0;

        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.a11y.notify(i18n('ui.shared.matching-options', {
                totalCount,
              }));
            })
            .catch(console.info);
        }, 1000);
      });

      window.swinger.eventHub.register('keyup input change reset animationend', `#${state.inputId}`, (e) => {
        window.clearTimeout(debounce);
        const { value } = window.swinger.eventHub.getTarget(e);

        if (value === previousValue) {
          return;
        }

        if (!value || value.length < 2) {
          emptyState();
          return;
        }

        debounce = window.setTimeout(() => {
          previousValue = value;

          const url = `${baseUrl}?q=${encodeURIComponent(value)}`;
          window.swinger.ajax(url)
            .then((result) => {
              Object.assign(state, result);
              app.store.dispatch({
                type: 'UPDATE',
                value: state,
              });
            })
            .catch((e) => {
              if (e) {
                console.error(e);
              }
            });
        }, isClickDummy ? 500 : 200);
      });
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/autocomplete/autocomplete.js